import { render, staticRenderFns } from "./ForumThreadsListView.vue?vue&type=template&id=4361f992&"
import script from "./ForumThreadsListView.vue?vue&type=script&lang=js&"
export * from "./ForumThreadsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports